import useGlobalStore, { globalInitialState } from '.'

export const resetGlobalStore = () => {
  useGlobalStore.setState(globalInitialState)
}
